import React, { useContext } from 'react'
import Select from 'meinian-package/src/baseComponent/select'
import { AccountContext } from '../../context'

const CLOTH_FLAG = { NOT: '1', HAVE: '2', IN: '3', OUT: '4' }

export default (props) => {
  const { userInfo = {} } = useContext(AccountContext)
  const { value, onChange } = props
  if (!userInfo?.isWhalePick) return null
  return <Select
    data={[{ label: '无样衣', value: CLOTH_FLAG.NOT },
      { label: '有样衣', value: CLOTH_FLAG.HAVE },
      { label: '已借出样衣', value: CLOTH_FLAG.IN },
      { label: '未借出样衣', value: CLOTH_FLAG.OUT }]}
    value={value}
    onChange={onChange}
    placeholder="样衣"
  />
}
